import { createContext } from 'react';

const LanguageContext = createContext<any>(undefined);

export default LanguageContext;
